/*https://www.zhihu.com/question/40508884*/
export default{
    install(Vue)
    {
        // 产品名称排序 升序
        Vue.prototype.productAsc= function(array, key) {
            array.sort(function (a, b) {
                if (a[key] == null) {
                    //为null排最后
                    return 1;
                } else {
                    //年月日
                    if (a[key].toString().indexOf('-') != -1) {
                        //按照日期排序时，如果是日期的2022-01-02时需要转成时间戳
                        return Number(new Date(a[key]).getTime()) - Number(new Date(b[key]).getTime());
                    }
                    //时间戳
                    else {
                            return a[key] - b[key];
                        }
                }
            });
            return array;
        };
        // 获取时间
        Vue.prototype.formateDate = function(datetime){
            var date = new Date(datetime); // 将时间戳转换为 Date 对象
        
            var year = date.getFullYear(),
                month = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
        
            var result = year + "-" + month + "-" + day;
            return result;
        };
        Vue.prototype.showFile = function(url, name='下载文件') {
            if (url.slice(-3).toLocaleLowerCase() === "pdf") {
              this.$root.$children[0].showPdf(url,name)
            }
            if (url.slice(-3).toLocaleLowerCase() === "doc" || url.slice(-4).toLocaleLowerCase() === "docx") {
              location.href =
                "https://view.officeapps.live.com/op/view.aspx?src=" + url;
            }
        };
        Vue.prototype.getUrlType= function(url) {
            let text = ''
            console.log('url', url.slice(-4))
            switch (url.slice(-4).toLowerCase()) {
                case '.doc':
                text = "doc"
                break;
                case '.pdf':
                text = "pdf"
                break;
                case 'docx':
                text = "docx"
                break;
                case '.png':
                text = "png"
                break;
                case '.jpg':
                text = "jpg"
                break;
                case 'jpeg':
                text = "jpeg"
                break;
                case '.mp4':
                text = "mp4"
                break;
                case '.xls':
                text = "xls"
                break;
                case 'xlsx':
                text = "xlsx"
                break;
                default:
                break;
            }
            return text
        }
    }
}
  
  
  